function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFB300",
  d: "M46.946 15.085l-17.5 12.461c-.133.092-11.758.092-11.891-.008L.079 14.946c.085-.309.235-.597.44-.846.205-.249.46-.453.75-.6L23.5 2.21 45.732 13.5c.312.156.583.38.794.654.21.275.354.593.42.93z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F6F6F6",
  d: "M37.6 0H9.4c-.623 0-1.22.243-1.662.676a2.287 2.287 0 00-.688 1.632v25.384h32.9V2.308c0-.612-.247-1.2-.687-1.632A2.372 2.372 0 0037.6 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFA000",
  d: "M46.946 15.085l-17.5 12.461c-.133.092-11.758.092-11.891-.008L.083 14.95c-.055.197-.082.4-.083.603v22.14c0 .612.249 1.199.69 1.631.44.433 1.037.676 1.66.677h42.3c.623 0 1.22-.244 1.661-.677.44-.432.688-1.02.689-1.63V15.551a2.272 2.272 0 00-.054-.47v.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FB8C00",
  d: "M46.812 38.584a2.315 2.315 0 01-.863 1.029A2.376 2.376 0 0144.65 40H2.35c-.462 0-.914-.135-1.299-.387a2.313 2.313 0 01-.863-1.029l21.025-14.838a3.952 3.952 0 012.287-.727c.822 0 1.622.255 2.287.727l21.025 14.838z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58220",
  d: "M23.5 20c4.327 0 7.834-3.444 7.834-7.692S27.827 4.615 23.5 4.615c-4.326 0-7.833 3.445-7.833 7.693 0 4.248 3.507 7.692 7.833 7.692z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: 0.833,
  d: "M22.032 14.594L19.799 12.4a.765.765 0 00-1.071-.005.733.733 0 00.005 1.052l2.748 2.7h.001l.006.006.003.003h0l.002.001a.756.756 0 001.057-.004l5.65-5.548a.725.725 0 00.004-1.038.756.756 0 00-1.058.004l-5.114 5.023z"
}));

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 40
  }, props), _ref);
}

export default SvgMail;